if (!customElements.get('sale-countdown')) {
  class SaleCountdown extends HTMLElement {
    connectedCallback() {
      this.startMs = Date.parse(this.dataset.start);
      const hours = Number(this.dataset.hours);
      const durationHours = Number.isFinite(hours) && hours > 0 ? hours : 48;
      this.endMs = this.startMs + durationHours * 60 * 60 * 1000;
      this.fallback = this.dataset.fallback || 'Shop Now';
      this.label = this.dataset.label || '48H SALE';
      this.phaseEl = this.querySelector('[data-phase]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      if (!Number.isFinite(this.startMs)) {
        this.showFallback();
        return;
      }

      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    tick() {
      const now = Date.now();
      if (now >= this.endMs) {
        this.showFallback();
        return;
      }

      const countingToStart = now < this.startMs;
      const remainingMs = (countingToStart ? this.startMs : this.endMs) - now;
      const totalSeconds = Math.floor(remainingMs / 1000);
      const hoursLeft = Math.floor(totalSeconds / 3600);
      const minutesLeft = Math.floor((totalSeconds % 3600) / 60);
      const secondsLeft = totalSeconds % 60;
      const pad = (value) => String(value).padStart(2, '0');

      if (this.phaseEl) this.phaseEl.textContent = countingToStart ? 'Starts in' : 'Ends in';
      if (this.hoursEl) this.hoursEl.textContent = pad(hoursLeft);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutesLeft);
      if (this.secondsEl) this.secondsEl.textContent = pad(secondsLeft);

      const phase = countingToStart ? 'starts in' : 'ends in';
      this.setAttribute(
        'aria-label',
        `${this.label} ${phase} ${hoursLeft} hours ${minutesLeft} minutes ${secondsLeft} seconds`
      );
    }

    showFallback() {
      window.clearInterval(this.timer);
      const fallback = document.createElement('span');
      fallback.textContent = this.fallback;
      this.replaceWith(fallback);
    }
  }

  customElements.define('sale-countdown', SaleCountdown);
}
